import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Row = styled.div`
    display: flex;
    gap: 10px;
    justify-content: center;
`;

export const Cell = styled.input`
    width: 56px;
    height: 64px;
    border: 1px solid ${colors.fieldBorder};
    border-radius: ${radii.base};
    background: ${colors.surface};
    font-family: inherit;
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    color: ${colors.textPrimary};
    outline: none;

    &:focus {
        border-color: ${colors.primary};
    }

    &:disabled {
        opacity: 0.6;
    }
`;
